export const mobileStickySubmitSx = {
  container: {
    position: "fixed",
    left: 0,
    width: "100%",
    padding: "8px 16px",
    boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
    zIndex: 999,
    display: { xs: "flex", md: "none" },
    justifyContent: "center",
  },
  submitBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: { xs: "100%", sm: "50%" },
    height: 55,
    bgcolor: "green",
    border: "2px solid grey",
    borderRadius: "30px",
    cursor: "pointer",
  },
};

export const createClassSx = {
  root: { minHeight: "100vh" },
  loaderWrapper: { height: "70vh" },
  gridContainer: { justifyContent: "center", px: { sm: 4, xs: 1 } },
  leftGrid: { my: { sm: 3, xs: 3, md: 4 } },
  topRow: {
    display: { xs: "flex", sm: "flex", md: "flex", lg: "block" },
    flexDirection: { xs: "column", sm: "column", md: "column", lg: "row" },
    justifyContent: { xs: "space-between", sm: "space-between", md: "space-between" },
    width: { xs: "100%", sm: "100%", md: "100%", lg: "66%" },
  },
  menuItem: {
    display: "block",
    minWidth: "200px",
    maxWidth: "300px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  datePicker: { width: "100%" },
  adornmentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "10px",
    height: "30px",
    fontWeight: "bold",
  },
  submitDesktopWrapper: { display: { xs: "none", md: "block" } },
  submitButton: {
    width: "100%",
    height: 55,
    bgcolor: "green",
    border: "2px solid grey",
    borderRadius: "30px",
    cursor: "pointer",
  },
  timezoneText: { pb: 1, fontSize: 14, fontWeight: "bold", textAlign: "center" },
  loadingTimesWrapper: {
    height: "60vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dayRow: { display: "flex", alignItems: "center", mb: 1, width: "100%" },
  checkbox: {
    "& .MuiSvgIcon-root": { fontSize: "30px !important" },
    cursor: "pointer",
  },
  dayCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid",
    borderRadius: "30px",
    flexDirection: { xs: "column", md: "row", lg: "row", xl: "row" },
  },
  dayLabelWrapper: { width: { sm: "100%", md: "20%", lg: "20%" } },
  dayLabel: { whiteSpace: "nowrap" },
  colon: { display: { xs: "none", md: "inline" }, whiteSpace: "nowrap" },
  timePickersRow: {
    mt: 1,
    mb: { xs: 3, sm: 1 },
    mr: { xs: 0, sm: "20px" },
    width: { xs: "100%", sm: "auto" },
    gap: { xs: 1, sm: 2, md: 2, lg: 2, xl: 2 },
  },
  mobileErrorWrapper: { display: { xs: "block", md: "none" } },
  mobileErrorText: { textAlign: "center", mt: 3 },
};
